module.exports = __webpack_public_path__ + "img/0060.0a3f78b2.png";